var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderOpenSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 576 512",
    style: {
      enableBackground: "new 0 0 576 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F3BBBB;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.7,223.8L0,375.8V96c0-35.3,28.7-64,64-64h117.5c17,0,33.3,6.7,45.3,18.7l26.5,26.5 c12,12,28.3,18.7,45.3,18.7H416c35.3,0,64,28.7,64,64v32H144c-22.8,0-43.8,12.1-55.3,31.8V223.8z M116.3,239.9 c5.8-9.9,16.3-15.9,27.7-15.9h400c11.5,0,22,6.1,27.7,16.1s5.7,22.2-0.1,32.1l-112,192C453.9,474,443.4,480,432,480H32 c-11.5,0-22-6.1-27.7-16.1s-5.7-22.2,0.1-32.1l112-192L116.3,239.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpenSolid);
export default __webpack_public_path__ + "static/media/folder-open-solid.35d702be1fe74d69579a3a218355c947.svg";
export { ForwardRef as ReactComponent };